// extracted by mini-css-extract-plugin
export default {"clockerContainer":"Clocker_clockerContainer__FLtYM","buttonBar":"Clocker_buttonBar__oRQnz","settingsModal":"Clocker_settingsModal__QjUty"};